// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { linkListStyles } from "@insite/content-library/Widgets/Basic/LinkList";
import { StyledButton } from "@insite/mobius/Clickable";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { headingsFontConfig } from "@pacific/XDL/PreStyle/typography";
import { xBlueprintName } from "@pacific/XDL/types";
import { color } from "@pacific/XDL/Utilities";
import { css } from "styled-components";

linkListStyles.titleWrapper = {
    css: css`
        font-family: ${headingsFontConfig[BLUEPRINT_NAME as xBlueprintName].fontFamily};
        margin-bottom: 15px;
        padding-bottom: 7px;
        border-bottom: 1px solid ${color("common.ui2", 0.2)};
        text-transform: capitalize;
        .list-title span {
            font-size: 14px;
            font-weight: bold;
            line-height: 19px;
            letter-spacing: 0;
        }
    `,
};

linkListStyles.title = {
    variant: "h6",
    css: css`
        margin-bottom: 0;
    `,
};

linkListStyles.linkWrapper = {
    css: css`
        ${StyledButton}, ${TypographyStyle} {
            font-size: 12px;
            font-weight: normal;
        }
    `,
};
